import { createContext, FC, ReactNode, useContext, useEffect, useMemo, useState } from 'react';

import { useRouter } from 'next/router';
import { useWindowSize } from 'react-use';
import { HOMEPAGE_PATHS } from 'src/v2/components/_constants';

const appStateContext = {
  width: 999999,
  height: 999999,
  isApp: false,
  isClient: false,
  currentRoute: '',
  currentPathname: '',
};

export const AppStateContext = createContext(appStateContext);

export const AppStateProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { pathname, route } = useRouter();
  const { width, height } = useWindowSize();
  const [isClient, setIsClient] = useState(false);

  const isApp = useMemo(() => !HOMEPAGE_PATHS.includes(pathname), [pathname]);
  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <AppStateContext.Provider
      value={{ width, height, isApp, isClient, currentPathname: pathname, currentRoute: route }}
    >
      {children}
    </AppStateContext.Provider>
  );
};

export function useAppStateContext() {
  const appStateCtx = useContext(AppStateContext);

  if (!appStateCtx) throw 'useAppStateContext not wrapped in provider.';

  return appStateCtx;
}
